module.exports = __webpack_public_path__ + "static/media/move_CONTAINER_to_DESTINATION.ea455af9.svg";